"use client"

import { Navigate, Route, Routes } from "react-router-dom"
import { EmployerOrganisationSettingsPage } from "@/components/employer/employer-organisation-settings-page"
import { EmployerOrganisationTeamPage } from "@/components/employer/employer-organisation-team-page"
import { EmployerOrganisationPreferencesSettingsPage } from "@/components/employer/employer-organisation-preferences-settings-page"
import { EmployerOrganisationBillingSettingsPage } from "@/components/employer/employer-organisation-billing-settings-page"
import {
  EMPLOYER_ORGANISATION_SETTINGS_BILLING_SEGMENT,
  EMPLOYER_ORGANISATION_SETTINGS_GENERAL_SEGMENT,
  EMPLOYER_ORGANISATION_SETTINGS_PREFERENCES_SEGMENT,
  EMPLOYER_ORGANISATION_SETTINGS_TEAM_SEGMENT,
} from "@/constants/employer-organisation-settings-nav"

type EmployerOrganisationSettingsRoutesProps = {
  slug: string
}

export function EmployerOrganisationSettingsRoutes({ slug }: EmployerOrganisationSettingsRoutesProps) {
  return (
    <Routes>
      <Route index element={<Navigate to={EMPLOYER_ORGANISATION_SETTINGS_GENERAL_SEGMENT} replace />} />
      <Route
        path={EMPLOYER_ORGANISATION_SETTINGS_GENERAL_SEGMENT}
        element={<EmployerOrganisationSettingsPage slug={slug} />}
      />
      <Route
        path={EMPLOYER_ORGANISATION_SETTINGS_TEAM_SEGMENT}
        element={<EmployerOrganisationTeamPage slug={slug} />}
      />
      <Route
        path={EMPLOYER_ORGANISATION_SETTINGS_PREFERENCES_SEGMENT}
        element={<EmployerOrganisationPreferencesSettingsPage slug={slug} />}
      />
      <Route
        path={EMPLOYER_ORGANISATION_SETTINGS_BILLING_SEGMENT}
        element={<EmployerOrganisationBillingSettingsPage slug={slug} />}
      />
      <Route path="*" element={<Navigate to={EMPLOYER_ORGANISATION_SETTINGS_GENERAL_SEGMENT} replace />} />
    </Routes>
  )
}
